import { VStack, Heading, Checkbox, Text, Button, useToast, HStack, Box } from "@chakra-ui/react";
import axios from "axios";
import { useState } from "react";

const AssignChecklists = ({ checklists, assignedChecklists, job, setAssignedChecklists, onClose }) => {
  const [selectedChecklists, setSelectedChecklists] = useState([]);
  const toast = useToast();

  const availableChecklists = checklists.filter(
    (checklist) => !assignedChecklists.some((assigned) => assigned.checklistName === checklist.checklistName)
  );

  if (!availableChecklists.length) return null;

  return (
    <>
      <Heading size='sm' textAlign='center' mb='4'>
        Assign Checklists to Job
      </Heading>
      <VStack spacing={3} align='stretch'>
        {availableChecklists.map((checklist) => (
          <HStack key={checklist._id} align='center'>
            <Checkbox
              //key={checklist._id}
              isChecked={selectedChecklists.includes(checklist._id)}
              onChange={(e) => {
                if (e.target.checked) {
                  setSelectedChecklists([...selectedChecklists, checklist._id]);
                } else {
                  setSelectedChecklists(selectedChecklists.filter((id) => id !== checklist._id));
                }
              }}
            >
              <HStack align='center'>
                <Text fontWeight='500'>{checklist.checklistName}</Text>
                {checklist.consoleId && (
                  <Text fontSize='sm' color='gray.500' ml={1}>
                    ({checklist.consoleId})
                  </Text>
                )}
              </HStack>
            </Checkbox>
          </HStack>
        ))}
      </VStack>
      <Box textAlign='center'>
        <Button
          my='6'
          colorScheme='blue'
          isDisabled={selectedChecklists.length === 0}
          onClick={async () => {
            try {
              const promises = selectedChecklists.map((checklistId) =>
                axios.post("/api/checklists/assign", {
                  checklistId,
                  jobNumber: job.JOB_NO,
                })
              );
              await Promise.all(promises);
              toast({
                title: "Success",
                description: `${selectedChecklists.length} checklist(s) assigned to job`,
                status: "success",
                duration: 3000,
              });
              setSelectedChecklists([]);
              // Refresh assigned checklists
              const { data } = await axios.get(`/api/checklists/job/${job.JOB_NO}`);
              setAssignedChecklists(data.checklists || []);
              if (onClose) onClose();
            } catch (error) {
              toast({
                title: "Error",
                description: "Failed to assign checklists",
                status: "error",
                duration: 3000,
              });
            }
          }}
        >
          Save Lists ({selectedChecklists.length} selected)
        </Button>
      </Box>
    </>
  );
};

export default AssignChecklists;
